import { HttpService } from '../../../@core/services/common/http.service';
import {
  ChangeDetectorRef,
  Component,
  Input,

} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { forwardRef } from '@angular/core';


@Component({
  selector: 'ch-file-field',
  templateUrl: './file-field.component.html',
  styleUrls: ['./file-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileFieldComponent),
      multi: true,
    },
  ],
})
export class FileFieldComponent implements ControlValueAccessor {
  @Input() accept: string = '*/*'; // allowed file types (e.g. '.pdf,.jpg,.png')
  @Input() isEditable: boolean = false;

  fileUrl: string | null = null;
  fileName: string | null = null;
  uploading = false;
  progress = 0;
  selectedFile?: File;
  previewDataUrl: string | null = null;

  private onChange: any = () => {};
  private onTouched: any = () => {};

  constructor(private cd: ChangeDetectorRef, private http: HttpService) {}

  writeValue(value: any): void {
    if (value) {
      this.fileUrl = value?.url || value?.fileUrl || (typeof value === 'string' ? value : null);
      this.fileName = value?.name || value?.fileName || null;
      if (this.fileUrl && this.isImage(this.fileUrl)) {
        this.previewDataUrl = this.fileUrl;
      }
    } else {
      this.fileUrl = null;
      this.fileName = null;
      this.previewDataUrl = null;
    }
    this.cd.detectChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onFileSelected(ev: Event): void {
    const input = ev.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      this.selectedFile = undefined;
      return;
    }
    this.selectedFile = input.files[0];
    this.fileName = this.selectedFile.name;

    // Generate preview if image
    if (this.selectedFile.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = () => {
        this.previewDataUrl = reader.result as string;
        this.cd.detectChanges();
      };
      reader.readAsDataURL(this.selectedFile);
    } else {
      this.previewDataUrl = null;
    }
    this.cd.detectChanges();
  }

  async upload(): Promise<void> {
    if (!this.selectedFile) return;
    this.uploading = true;
    this.progress = 0;
    this.onTouched();

    try {
      const result = await this.http.uploadFile(this.selectedFile).toPromise();
       this.applyUploadResult(result);
       this.selectedFile = undefined;
     } catch (err) {
       console.error('Upload failed', err);
     } finally {
       this.uploading = false;
       this.cd.detectChanges();
     }
   }

  private applyUploadResult(result: any) {
    // Strapi v5 upload response shape: { id, name, url, ... }
    const url = result?.url || result?.fileUrl || result?.path || (typeof result === 'string' ? result : null);
    const name = result?.name || result?.fileName || this.fileName;
    this.fileUrl = url;
    this.fileName = name || this.fileName;
    // emit the full file object with numeric id so prepRecordForApi can extract it
    const newValue = result; // keep the full object { id, documentId, url, name, ... }
     this.onChange(newValue);
     this.cd.detectChanges();
   }


  view(): void {
    if (this.fileUrl) {
      window.open(this.fileUrl, '_blank');
    }
  }

  remove(): void {
    this.fileUrl = null;
    this.fileName = null;
    this.previewDataUrl = null;
    this.selectedFile = undefined;
    this.onChange(null);
    this.onTouched();
    this.cd.detectChanges();
  }

  private isImage(nameOrUrl: string): boolean {
    return /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(nameOrUrl);
  }
}